<template>
    <component :is="template">
        <v-container>
            <div class="contents-area">
                <div class="contents-area__inner mx-auto" style="max-width:800px">
                    <div class="tit-wrap tit-wrap--unberline">
                        <h2 class="tit">자동충전</h2>
                        <div class="mt-4px mt-lg-8px font-size-14 font-size-md-16 grey--text text--garken-3">
                            선물받은 나누리 캐시를 충전하실 수 있습니다.
                        </div>
                    </div>

                    <v-responsive width="100%" max-width="400" class="mx-auto" style="overflow: visible">
                        <template v-if="false"> </template>
                        <template v-else-if="mode == 'auth'">
                            <v-card class="py-6 py-lg-12">
                                <v-card-title class="pt-3 pt-lg-6 justify-center">
                                    <span> 다른 회원에게 충전된 선물입니다. </span>
                                </v-card-title>
                                <v-card-text class="pb-3 pb-lg-6 text-center">
                                    <span> 다시 로그인 해주세요. </span>
                                </v-card-text>
                                <v-card-actions class="justify-center">
                                    <v-btn large color="primary" class="w-lg-160px" to="/login" v-bind="{ loading }">
                                        <span> 다시 로그인 하기 </span>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </template>
                        <template v-else-if="mode == 'done'">
                            <v-card class="py-6 py-lg-12">
                                <v-card-text class="pt-3 pt-lg-6 text-center">
                                    <span>
                                        <b>{{ gift.gifter?.name || "홍길동" }}</b>
                                        님이 선물하신 나누리 캐시
                                    </span>
                                </v-card-text>
                                <v-card-title class="pt-0 pb-3 pb-lg-6 justify-center">
                                    <span> {{ gift.amount.format() }}원 </span>
                                </v-card-title>
                                <v-card-actions class="justify-center">
                                    <v-btn large outlined color="primary" class="w-lg-160px" v-bind="{ loading }" to="/mypage/cashes/inquiry">
                                        <span> 충전 완료 </span>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </template>
                        <template v-else-if="mode == 'form'">
                            <v-card class="py-6 py-lg-12">
                                <v-card-text class="pt-3 pt-lg-6 text-center">
                                    <span>
                                        <b>{{ gift.gifter?.name || "홍길동" }}</b>
                                        님이 선물하신 나누리 캐시
                                    </span>
                                </v-card-text>
                                <v-card-title class="pt-0 pb-3 pb-lg-6 justify-center">
                                    <span> {{ gift.amount.format() }}원 </span>
                                </v-card-title>
                                <v-card-actions class="justify-center">
                                    <template v-if="_user">
                                        <v-btn large color="primary" class="w-lg-160px" v-bind="{ loading }" @click="exec">
                                            <span> 나누리 캐시 충전하기 </span>
                                        </v-btn>
                                    </template>
                                    <template v-else>
                                        <v-btn large color="primary" class="w-lg-160px" to="/login" v-bind="{ loading }">
                                            <span> 로그인 후 충전하기 </span>
                                        </v-btn>
                                    </template>
                                </v-card-actions>
                            </v-card>
                        </template>
                        <template v-else-if="mode == 'none'">
                            <v-card class="py-6 py-lg-12">
                                <v-card-title class="pt-3 pt-lg-6 justify-center">
                                    <span> 취소된 선물입니다. </span>
                                </v-card-title>
                                <v-card-text class="pb-3 pb-lg-6 text-center">
                                    <span> 자동충전 URL을 다시 확인해주세요. </span>
                                </v-card-text>
                            </v-card>
                        </template>
                        <template v-else-if="mode == 'null'">
                            <v-card class="py-6 py-lg-12">
                                <v-card-title class="pt-3 pt-lg-6 justify-center">
                                    <span> 선물 내역을 찾을 수 없습니다. </span>
                                </v-card-title>
                                <v-card-text class="pb-3 pb-lg-6 text-center">
                                    <span> 자동충전 URL을 다시 확인해주세요. </span>
                                </v-card-text>
                            </v-card>
                        </template>
                    </v-responsive>
                </div>
            </div>
        </v-container>
        <common-loader v-bind="{ loading }" />
    </component>
</template>
<script>
import api from "@/api";
import { mapActions } from "vuex";
import { initUserExchangeGift } from "@/assets/lib";

import CommonLoader from "@/components/common/common-loader.vue";

export default {
    components: {
        CommonLoader,
    },
    props: {
        _gift: { type: String, default: null },
    },
    data: () => ({
        /** @type {import('@/assets/lib').UserExchangeGift} */
        gift: initUserExchangeGift(),
        loading: false,
    }),
    computed: {
        _user() {
            return this.$store.state.payload?._user;
        },
        template() {
            return () => import(`@/templates/${this.$theme.pages.gshop}`);
        },
        mode() {
            if (this.gift._id) {
                if (!!this.gift._giftee && !!this._user) {
                    if (this.gift._giftee != this._user) return "auth";
                }

                if (this.gift.undone) return "none";

                if (0 < this.gift.bulk?.exchanges_toGift?.length) {
                    return "form";
                }

                return "done";
            } else if (!this.loading) return "null";
        },
    },
    methods: {
        ...mapActions(["getUser"]),

        async init() {
            this.gift = initUserExchangeGift();

            this.loading = true;

            let { _gift } = this;
            try {
                let { gift } = await api.v1.me.exchanges.gifts.get({ _id: _gift });
                if (this._gift == _gift) this.gift = initUserExchangeGift(gift);
            } finally {
                if (this._gift == _gift) this.loading = false;
            }
        },
        async exec() {
            let go = await this.$confirm("나누리 캐시를 충전하시겠습니까?");
            if (!go) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                let { gift } = await api.v1.me.exchanges.gifts.cash.postExec({ _id: this._gift });

                this.gift = initUserExchangeGift(gift);

                this.getUser();
            } finally {
                this.loading = false;
            }
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
.exchange-list-item-card__overlay {
    position: absolute;
    bottom: 0;
    width: 100%;

    align-items: end;
    justify-content: stretch;

    &::v-deep .v-overlay__content {
        width: 100%;
    }
}
</style>
